<template>
    <div class="create-location">
        <form-component ref="form" class="new-location-page container" v-if="!locationCreated">
            <div class="row">
                <div class="col">
                    <div class="box">
                        <h4>Woonlocatie gegevens</h4>
                        <p v-if="locationNameErrorMessage" class="errorMessage">{{ locationNameErrorMessage }}</p>
                        <input-component type="text" label="Naam" v-model="newLocation.locationName"></input-component>
                        <p v-if="streetNameErrorMessage" class="errorMessage">{{ streetNameErrorMessage }}</p>
                        <input-component type="text" label="Straatnaam" v-model="newLocation.streetName"></input-component>
                        <p v-if="streetNumberErrorMessage" class="errorMessage">{{ streetNumberErrorMessage }}</p>
                        <input-component type="number" label="Huisnummer" v-model="newLocation.streetNumber"></input-component>
                        <p v-if="postalCodeErrorMessage" class="errorMessage">{{ postalCodeErrorMessage }}</p>
                        <input-component type="text" label="Postcode" v-model="newLocation.postalCode"></input-component>
                        <p v-if="cityErrorMessage" class="errorMessage">{{ cityErrorMessage }}</p>
                        <input-component type="text" label="Plaatsnaam" v-model="newLocation.city"></input-component>
                        <p v-if="phoneNumberErrorMessage" class="errorMessage">{{ phoneNumberErrorMessage }}</p>
                        <input-component type="text" label="Telefoonnummer" v-model="newLocation.phoneNumber"></input-component>
                        <input-component type="text" label="Telegram group ID" v-model="newLocation.telegramGroupId"></input-component>

                      <input-component type="number" step="any" label="GPS locatie (lat)" v-model="newLocation.gpsLocationLat"></input-component>
                      <input-component type="number" step="any" label="GPS locatie (lng)" v-model="newLocation.gpsLocationLng"></input-component>

                      <label for="isSmsServiceActivated">SMS berichten service</label>
                      <label class="checkbox-container">
                        <input type="checkbox"
                               id="isSmsServiceActivated"
                               v-model="newLocation.smsServiceActivated"
                               :checked="newLocation.smsServiceActivated">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                </div>

                <div class="col">
                    <div class="box">
                        <h4>Bellen bij geen gehoor</h4>
                        <div class="add-contacts">
                            <div :key="i" v-for="(contact, i) in newLocation.contacts">
                                <p @click="removeContact(i)">X</p>
                                <p v-if="!contactIsValid(contact)" class="errorMessage">{{ contactIsInvalidErrorMessage }}</p>
                                <input-component required="required" label="Naam" v-model="contact.contactName"></input-component>
                                <input-component required="required" label="Nummer" v-model="contact.phoneNumber"></input-component>
                                <hr>
                            </div>
                            <button
                                    ref="addButton"
                                    class="add-button"
                                    @click="addContact"
                            >+</button>
                        </div>
                    </div>
            </div>
            </div>
            <button-component @click.native="saveNewLocation">Opslaan</button-component>
        </form-component>

        <div class="location-created" v-if="locationCreated">
            <div class="complete-image"></div>
            <p class="complete-title">Locatie {{ this.newLocation.locationName }} aangemaakt, u wordt teruggestuurd naar het overzicht</p>
            <circle-component position="bottom-center" height=236 />
        </div>
    </div>
</template>

<script>
import { RouteName } from '../../utils/enums';
import ButtonComponent from '../../components/button.component.vue';
import FormComponent from '../../components/fields/form.component.vue';
import InputComponent from '../../components/fields/input.component.vue';
import CircleComponent from '../../components/circle.component';
import { Location } from '../../domain/location';
import { isValidZipcode, isValidPhoneNumber, lastContactIsValid } from '../../utils/validators';

export default {
    name: 'admin-new-location-page',
    components: {
        FormComponent,
        InputComponent,
        ButtonComponent,
        CircleComponent
    },
    data() {
        return {
            newLocation: Location,
            locationCreated: false,
            locationNameErrorMessage: null,
            streetNameErrorMessage: null,
            streetNumberErrorMessage: null,
            postalCodeErrorMessage: null,
            cityErrorMessage: null,
            phoneNumberErrorMessage: null,
            contactIsInvalidErrorMessage: null,
            buttonDisabled: false
        };
    },
    created() {
        this.newLocation = {
            locationName: null,
            streetName: null,
            streetNumber: null,
            postalCode: null,
            city: null,
            phoneNumber: null,
            contacts: []
        };
    },
    methods: {
        validateForm: function() {
            !this.newLocation.locationName ? this.locationNameErrorMessage = 'Naam is verplicht' : this.locationNameErrorMessage = null;
            !this.newLocation.streetName ? this.streetNameErrorMessage = 'Straatnaam is verplicht' : this.streetNameErrorMessage = null;
            !this.newLocation.streetNumber ? this.streetNumberErrorMessage = 'Huisnummer is verplicht' : this.streetNumberErrorMessage = null;
            !isValidZipcode(this.newLocation.postalCode) ? this.postalCodeErrorMessage = 'Postcode is niet geldig' : this.postalCodeErrorMessage = null;
            !this.newLocation.city ? this.cityErrorMessage = 'Plaatsnaam is verplicht' : this.cityErrorMessage = null;
            !isValidPhoneNumber(this.newLocation.phoneNumber) ? this.phoneNumberErrorMessage = 'Telefoonnummer is niet geldig (0031)' : this.phoneNumberErrorMessage = null;
            !lastContactIsValid(this.newLocation.contacts) ? this.contactIsInvalidErrorMessage = 'Contact is niet juist ingevoerd' : this.contactIsInvalidErrorMessage = null;

            return !this.locationNameErrorMessage &&
                    !this.streetNameErrorMessage &&
                    !this.streetNumberErrorMessage &&
                    !this.postalCodeErrorMessage &&
                    !this.cityErrorMessage &&
                    !this.phoneNumberErrorMessage &&
                    !this.contactIsInvalidErrorMessage;
        },
        addContact: function() {
            if (lastContactIsValid(this.newLocation.contacts)) {
                this.newLocation.contacts.push({
                    contactName: '',
                    phoneNumber: ''
                });
            }
            // Scroll a bit down so the user can add multiple contacts quickly
            this.$refs.addButton.scrollIntoView();
        },
        contactIsValid: function(contact) {
            return contact.contactName.length > 0 && contact.phoneNumber.length >= 3;
        },
        removeContact(index) {
            this.newLocation.contacts.splice(index, 1);
        },
        saveNewLocation() {
            if (this.validateForm() && !this.buttonDisabled) {
                this.buttonDisabled = true; // disable after first click, to prevent multiple locations are saven
                this.$store.dispatch('SAVE_NEW_LOCATION', this.newLocation)
                    .then(response => {
                        if (response.status === 201) { // created, show confirmation
                            this.locationCreated = true; // redirect back after 2 seconds
                            setTimeout(() => {
                                this.$router.push({name: RouteName.ADMIN_LOCATIONS});
                            }, 2500);
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    })
            } else {
                console.error('Niet alle velen zijn juist ingevoerd');
            }
        }
    }
};
</script>

<style scoped lang="scss">
    @import '~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css';
    .row {
        flex-direction: column;

        @include desktop {
            flex-direction: row;
        }
    }

    .box {
        margin-bottom: 2rem;

        @include desktop {
            background-color: $white;
            // height: 100%;
            padding: 1rem;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 0.25rem;
        }

        h4 {
            font-weight: 400;
            margin-bottom: 1rem;
            color: $gray-darkest;
        }
        .errorMessage {
            color: $error;
            font-size: 12px;
            font-weight: normal;
        }

        p {
            color: $error;
            font-weight: bold;
            margin-bottom: 0px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .add-contacts {
        border-radius: 4px;
        border: 1px solid $gray;
        padding: 1rem;
        position: relative;
        margin-bottom: 1rem;

        .add-button {
            $button-size: 42px;
            position: absolute;
            bottom: -($button-size / 2);
            left: 50%;
            margin-left: -($button-size / 2);
            width: $button-size;
            height: $button-size;
            border-radius: 50%;
            background-color: $primary;
            color: $white;
            font-weight: bold;

            &:hover {
                background-color: $lightGreen;
            }
        }
    }

    .subtitle {
        margin: 1rem 0;
        display: block;
        font-weight: 500;
    }

    .seperator {
        margin: 2rem 0;
        background-color: $gray;
    }

    .input-component,
    .switch-component {
        margin-bottom: 1rem;
    }

    .row-wrapper {
        display: flex;

        .input-component {
            flex-grow: 1;

            &:first-child {
                margin-right: 60px;
            }
        }
    }

    .smartwatch-bg-color {
        margin-bottom: 1rem;
    }
    .location-created {
        height: 100%;
        background-color: $primary;
        color: $white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .complete-title {
            margin-bottom: 14px;
        }

        p {
            font-size: 16px;
            text-align: center;
        }
    }

    .complete-image {
        width: 95px;
        height: 120px;
        background-image: url('../../assets/icons/watch-large-complete.svg');
        margin-bottom: 64px;
        margin-top: -60px;
    }
</style>
